<script setup lang="ts">
	import { twMerge } from 'tailwind-merge'
	const { class: classes, ...attrs } = useAttrs()
</script>

<template>
	<div class="size-7.5 lg:mt-1.5">
		<button :class="twMerge('w-full h-full flex flex-col gap-y-2 group cursor-pointer', classes)" aria-label="Navigation öffnen" title="Navigation öffnen">
			<span class="block w-full border-t-[3px] border-primary group-hover:translate-y-2.75 transition-all duration-150 ease-in-out"></span>
			<span class="block w-full border-t-[3px] border-primary"></span>
			<span class="block w-full border-t-[3px] border-primary group-hover:-translate-y-2.75 transition-all duration-150 ease-in-out"></span>
		</button>
	</div>
</template>
